/* ================================================================
   EL TIPO RARO — REVISIÓN BF (borrador, 23-oct-2026)
   Comportamientos pequeños y reversibles. Para quitarlos todos basta
   con borrar su <script> en layout/theme.liquid.

   1. Alto real de la cabecera fija → variable CSS (anclas que no
      quedan tapadas por el menú).
   2. Guía de tallas: abrir / cerrar el <dialog> (snippet etr-guia-tallas).
   3. Talla consciente: sin talla preseleccionada (salvo enlace directo a
      una variante). Si se intenta añadir sin elegir, aviso claro y foco
      en las tallas. Funciona también en "Ver tallas" (añadido rápido).
   4. Orden de colección: "Características" → "Destacados".
   ================================================================ */
(function () {
  'use strict';

  /* ── 1. ALTO DE CABECERA ─────────────────────────────────────── */
  function setHeaderHeight() {
    var h = document.querySelector('.section-header');
    var px = h ? Math.round(h.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--etr-header-h', (px || 0) + 'px');
  }
  window.addEventListener('resize', setHeaderHeight, { passive: true });
  document.addEventListener('DOMContentLoaded', setHeaderHeight);

  /* ── 2. GUÍA DE TALLAS ───────────────────────────────────────── */
  var lastOpener = null;
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-etr-guia-abrir]');
    if (opener) {
      var wrap = opener.closest('[data-etr-tallas]');
      var dlg = wrap && wrap.querySelector('dialog.etr-guia');
      if (dlg && typeof dlg.showModal === 'function') {
        e.preventDefault();
        lastOpener = opener;
        marcarTallaActual(dlg);
        dlg.showModal();
      }
      return;
    }
    var closer = e.target.closest('[data-etr-guia-cerrar]');
    if (closer) {
      var d = closer.closest('dialog');
      if (d) d.close();
      return;
    }
    /* clic fuera de la caja = cerrar */
    if (e.target.matches && e.target.matches('dialog.etr-guia')) {
      e.target.close();
    }
  });
  document.addEventListener('close', function (e) {
    if (e.target.matches && e.target.matches('dialog.etr-guia') && lastOpener) {
      try { lastOpener.focus({ preventScroll: true }); } catch (err) {}
    }
  }, true);

  /* Resalta en la tabla la talla que está marcada, si hay una */
  function marcarTallaActual(dlg) {
    var info = dlg.closest('product-info') || document;
    var fs = tallaFieldset(info);
    var sel = fs && fs.querySelector('input:checked');
    var body = dlg.querySelector('.etr-guia__medidas');
    if (!body) return;
    body.querySelectorAll('.etr-guia__fila-activa').forEach(function (n) { n.classList.remove('etr-guia__fila-activa'); });
    if (!sel || estado(info) === 'pendiente') return;
    var talla = sel.value.trim();
    /* Las medidas vienen como líneas "· M — 55,5 × 75 × 24"; envolvemos solo la de la talla marcada */
    var html = body.innerHTML;
    if (body.dataset.etrOriginal) html = body.dataset.etrOriginal; else body.dataset.etrOriginal = html;
    var alias = talla === '2XL' ? '(?:XXL \\(2XL\\)|2XL|XXL)' : talla.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var re = new RegExp('(·\\s*' + alias + '\\s*—[^<]*)');
    body.innerHTML = html.replace(re, '<span class="etr-guia__fila-activa">$1</span>');
  }

  /* ── 3. TALLA CONSCIENTE ─────────────────────────────────────── */
  function tallaFieldset(root) {
    var list = root.querySelectorAll('variant-selects fieldset');
    for (var i = 0; i < list.length; i++) {
      var lg = list[i].querySelector('legend');
      var t = lg ? lg.textContent.trim().toLowerCase() : '';
      if (t.indexOf('talla') === 0 || t.indexOf('size') === 0) return list[i];
    }
    return null;
  }
  function estado(root) { return root && root.dataset ? root.dataset.etrTalla : null; }
  function mainForm(root) { return root.querySelector('form[data-type="add-to-cart-form"]'); }
  function submitBtn(root) {
    var f = mainForm(root);
    return f ? f.querySelector('button[type="submit"], button[name="add"]') : null;
  }
  function setBtnLabel(root, txt) {
    var b = submitBtn(root);
    if (!b) return;
    var span = b.querySelector('span') || b;
    if (txt) {
      if (!b.dataset.etrTxt) b.dataset.etrTxt = span.textContent;
      span.textContent = txt;
      b.setAttribute('aria-describedby', avisoId(root));
    } else if (b.dataset.etrTxt) {
      if (span.textContent.trim() === 'Elige tu talla') span.textContent = b.dataset.etrTxt;
      delete b.dataset.etrTxt;
      b.removeAttribute('aria-describedby');
    }
  }
  function aviso(root) { return root.querySelector('[data-etr-talla-aviso]'); }
  function avisoId(root) {
    var a = aviso(root);
    if (!a) return '';
    if (!a.id) a.id = 'EtrTallaAviso-' + Math.random().toString(36).slice(2, 8);
    return a.id;
  }

  function prepararTalla(root) {
    if (!root || root.dataset.etrTalla) return;
    var fs = tallaFieldset(root);
    if (!fs) return;
    var radios = fs.querySelectorAll('input[type="radio"]');
    if (radios.length < 2) return;
    var enModal = !!root.closest('quick-add-modal');
    var url = new URL(window.location.href);
    if (!enModal && url.searchParams.get('variant')) {
      root.dataset.etrTalla = 'elegida';   /* enlace directo a una talla: se respeta */
      return;
    }
    root.dataset.etrTalla = 'pendiente';
    limpiarTalla(root);
  }

  function limpiarTalla(root) {
    var fs = tallaFieldset(root);
    if (!fs) return;
    fs.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = false; });
    fs.classList.add('etr-talla-pendiente');
    setBtnLabel(root, 'Elige tu talla');
  }

  /* El usuario elige talla → se acaba el bloqueo; Dawn repinta el botón */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    var root = input.closest('product-info');
    if (!root || estado(root) !== 'pendiente') return;
    var fs = input.closest('fieldset');
    if (fs && fs === tallaFieldset(root)) {
      root.dataset.etrTalla = 'elegida';
      fs.classList.remove('etr-talla-pendiente');
      var a = aviso(root);
      if (a) a.hidden = true;
      setBtnLabel(root, null);
      syncPago(root);
    }
  }, true);

  /* 25-oct-2026 — Pago rápido en la ficha (Shop Pay / Google Pay / Apple Pay / PayPal):
     mientras no hay talla elegida, el botón queda apagado (inert) para que nadie
     compre la talla por defecto sin querer. Un clic encima avisa igual que "Elige tu talla". */
  function syncPago(root) {
    var pendiente = estado(root) === 'pendiente';
    root.querySelectorAll('.shopify-payment-button').forEach(function (pb) {
      pb.classList.toggle('etr-pago-bloqueado', pendiente);
      Array.prototype.forEach.call(pb.children, function (c) {
        if (pendiente) c.setAttribute('inert', '');
        else c.removeAttribute('inert');
      });
    });
  }
  document.addEventListener('click', function (e) {
    var pb = e.target && e.target.closest ? e.target.closest('.shopify-payment-button') : null;
    if (!pb) return;
    var root = pb.closest('product-info');
    if (!root || estado(root) !== 'pendiente') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    avisarTalla(root);
  }, true);

  /* Intento de añadir sin talla → no se añade nada, aviso y foco en tallas */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    var root = form.closest('product-info');
    if (!root || estado(root) !== 'pendiente') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    avisarTalla(root);
  }, true);

  function avisarTalla(root) {
    var a = aviso(root);
    if (a) { a.hidden = false; }
    var fs = tallaFieldset(root);
    if (fs) {
      fs.classList.add('etr-talla-error');
      setTimeout(function () { fs.classList.remove('etr-talla-error'); }, 1600);
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = fs.querySelector('input[type="radio"]:not(.disabled):not([disabled])') || fs.querySelector('input[type="radio"]');
      if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (err) {} }, 350);
    }
  }

  /* Dawn repinta el selector al cambiar otra opción (p. ej. "Corte"):
     si la talla aún no se ha elegido, se vuelve a dejar sin marcar. */
  function revisar() {
    document.querySelectorAll('product-info').forEach(function (root) {
      if (!root.dataset.etrTalla) prepararTalla(root);
      syncPago(root);
      if (root.dataset.etrTalla !== 'pendiente') return;
      var fs = tallaFieldset(root);
      if (fs && (fs.querySelector('input:checked') || !fs.classList.contains('etr-talla-pendiente'))) limpiarTalla(root);
      else {
        var b = submitBtn(root);
        if (b && !b.dataset.etrTxt) setBtnLabel(root, 'Elige tu talla');
      }
    });
    renombrarOrden();
  }

  /* ── 4. "CARACTERÍSTICAS" → "DESTACADOS" ─────────────────────── */
  function renombrarOrden() {
    document.querySelectorAll('select[name="sort_by"] option[value="manual"]').forEach(function (o) {
      if (o.textContent.trim() !== 'Destacados') o.textContent = 'Destacados';
    });
  }

  /* setTimeout (no requestAnimationFrame): rAF se congela con la pestaña en
     segundo plano y dejaría el observador bloqueado. */
  var pend = false;
  var mo = new MutationObserver(function () {
    if (pend) return;
    pend = true;
    setTimeout(function () {
      pend = false;
      try { revisar(); } catch (err) { /* nunca romper la ficha */ }
    }, 30);
  });
  function init() {
    setHeaderHeight();
    revisar();
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
